import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { ObjectTypeClientT, ObjectTypePropertyCollectionItemT } from 'bovaljaren-models';
import React, { ReactElement, useContext } from 'react';
import { ObosChevronDown, ObosChevronUp } from '../../../../icons/obos/obosIcons';
import BrandingService from '../../../../services/branding.service';
import { AppContext } from '../../../../state/app.state';
import { objectTypePropertySorting } from '../../../../utils/objectType.helper';
import { ObjectSortingT, rejectedObjectListProperties } from '../ObjectList';

type ObjectListHeaderProps={
    sorting: ObjectSortingT;
    setSorting: (value: ObjectSortingT) => void;
    objectType: ObjectTypeClientT;
    filterdata: (type: ObjectTypePropertyCollectionItemT) => boolean;
};

const ObjectListHeader: React.FC<ObjectListHeaderProps> = ({ sorting, setSorting, objectType, filterdata }): ReactElement => {
    const { state } = useContext(AppContext);

    const onSortChange = (column: ObjectTypePropertyCollectionItemT): void => {
        if (!sorting.column || (sorting.column.type !== column.type || sorting.column.name !== column.name)) {
            setSorting({ sort: true, column, order: true });
        }
        else {
            setSorting({
                sort: sorting.order,
                order: !(sorting.order && sorting.sort),
                column: sorting.order ? column : undefined
            });
        }
    };

    const getArrow = () => {
        let style = { width: '0.75rem', height: '0.75rem', fill: 'white' };

        if (BrandingService.check(['obos'])) {
            style = { width: '1rem', height: '1rem', fill: 'white' };

            return (sorting.order ? <ObosChevronDown style={style}/> : <ObosChevronUp style={style}/>);
        }

        return (sorting.order ? <ArrowDownward style={style}/> : <ArrowUpward style={style}/>);
    };


    return (
        <thead style={{ backgroundColor: '#008761' }}>
            <tr className='bv-object-list-header-row'>
                <th className={'bv-object-list-status bv-object-list-status-header'}></th>
                <th className={'bv-object-list-identifier bv-object-list-header'}
                    style={{ textDecoration: sorting.column?.type === 'name' && sorting.sort ? 'underline' : '' }}
                    onClick={(): void => onSortChange({
                        id: 0,
                        objectTypeId: objectType.id,
                        sortOrder: 0,
                        name: 'Name',
                        type: 'name',
                        baseType: 'string',
                        ending: ''
                    })}>
                        Namn {sorting.column?.type === 'name' ? getArrow() : <div className={'bv-filler-stuff'}/>}
                </th>
                {objectType.properties.filter(p => !rejectedObjectListProperties.find(rOLP => rOLP === p.type)).sort(objectTypePropertySorting)
                    .filter(t => filterdata(t))
                    .map((t, i) => {

                        return <th key={i} className={'bv-object-list-header'} style={{ textDecoration: sorting.column === t ? 'underline' : '' }} onClick={(): void => onSortChange(t)}>{t.name} {sorting.column === t ? getArrow() : <div className={'bv-filler-stuff'}/>}</th>;
                    })}
                {state?.project?.config?.favorites &&
                <th className={'bv-object-list-favourite bv-object-list-favourite-header'} ></th>}
            </tr>
        </thead>
    );
};


export default ObjectListHeader;